<template>
  <div class="wrapper">
    <div class="animated fadeIn">
        <div style="margin-left: -2rem;margin-right: -2rem;">
        <b-breadcrumb :items="items" v-if="thai_student==1" />
        <b-breadcrumb :items="items_eng" v-if="thai_student==0" />
      </div>
      <create-bio></create-bio>
      <create-part3></create-part3>
    </div>
  </div>
</template>

<script>
import CreatePart3 from "../../components/CreatePart3.vue";
import CreateBio from "../../components/CreateBio.vue";

export default {
  components: {
    CreatePart3,
    CreateBio
  },
  name: "Part3",
  data() {
    return {
      items: [
        {
          text: "หน้าหลัก",
          href: "#/main"
        },
        {
          text: "ภาวะการมีงานทำ",
          href: "#"
        }
      ],
      items_eng: [
        {
          text: "Home",
          href: "#/main"
        },
        {
          text: "Employment Survey",
          href: "#"
        }
      ],
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {
    this.thai_student = this.$store.state.user.thaistudent;
  }
};
</script>
<style>
</style>
